import { post } from "@/request/http";
import encrypt from "@/plugins/encrypt";

// 显示虚拟项目列表
// 文档地址：http://showdoc.mools.net/web/#/13?page_id=107
export const showVirtualSimulation = p =>
    post("/exp/showVirtualSimulation", {
        params: encrypt(p)
    });
